/* istanbul ignore file */
import DetailsBlock from './DetailsBlock'
import withLoader from 'rental-car-contract/js/components/withLoader'
import RentalCarContractProcessCompactPlaceholder from '../../../ui/RentalCarContractProcessCompactPlaceholder'

export default withLoader(RentalCarContractProcessCompactPlaceholder)(DetailsBlock)
